module.exports = require('./src/ScrollLock');



//////////////////
// WEBPACK FOOTER
// ./~/react-scrolllock/index.js
// module id = 2126
// module chunks = 0